import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "i-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { ref } from 'vue';
export default {
  __name: 'IDialog',
  props: {
    cancelShow: {
      type: Boolean,
      default: true
    },
    confirmTilte: {
      type: String,
      default: '确认'
    },
    width: {
      type: String,
      default: '20%'
    },
    draggable: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    onConfirm: {
      type: Function,
      default: () => {}
    },
    isShowBtns: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: true
    },
    closedCb: {
      type: Function,
      default: null
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const dialogVisible = ref(false);
    const changeDialogVisible = (status = false) => {
      console.log('changeDialogVisible', status);
      dialogVisible.value = status;
    };
    const dialogClosed = () => {
      changeDialogVisible();
      props.closedCb && props.closedCb();
    };
    expose({
      changeDialogVisible
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        width: __props.width,
        "model-value": dialogVisible.value,
        onClosed: dialogClosed,
        "destroy-on-close": __props.destroyOnClose,
        title: __props.title,
        "show-close": __props.showClose,
        draggable: __props.draggable
      }, _createSlots({
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "content")]),
        _: 2
      }, [__props.isShowBtns ? {
        name: "footer",
        fn: _withCtx(() => [_createElementVNode("span", _hoisted_2, [__props.cancelShow ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = $event => changeDialogVisible(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "primary",
          onClick: __props.onConfirm
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.confirmTilte), 1)]),
          _: 1
        }, 8, ["onClick"])])]),
        key: "0"
      } : undefined]), 1032, ["width", "model-value", "destroy-on-close", "title", "show-close", "draggable"])]);
    };
  }
};